import { OptionDto } from "@/dtos";
import { IncidenceCondition } from "@/helpers/types";

const conditions = [
    { value: IncidenceCondition.OPEN, label: 'Abierto' },
    { value: IncidenceCondition.CLOSE, label: 'Cerrado' },
] as OptionDto[];

export const getConditionOptions = (): OptionDto[] => {
    return conditions;
}

export const getConditionOption = (value?: number): OptionDto => {
    return conditions.find((x) => x.value == value) ?? conditions[0];
}